import React from "react";

interface ScopeHeaderInterface {
  bgImage: string;
  bgColor: string;
  linearGradient?: string;
  txtColor: string;
  title: string;
  description: string;
}

export default function ScopeHeader({
  bgImage,
  bgColor,
  linearGradient,
  txtColor,
  title,
  description,
}:ScopeHeaderInterface) {
  return (
    <div
      className="bannerWrapper"
       style={{
        background: `url(${bgImage})` ,
        color: txtColor,
      }}
    >
      <div className="title">{title}</div>
      <div className="description">
        {description}
      </div>
    </div>
  );
}
